import * as API from "common/api";
import { io } from "socket.io-client";

const socket = io(API.SITE_URL, { path: API.SOCKET_PATH });

export default socket;
